import BaseTracker from './base-tracker';

export default class UnmuteTracker extends BaseTracker {
  _isMuted = false;

  start() {
    this._isMuted = this._player.model.volume === 0;
    this._player.addEventListener('volumechange', this._onVolumeChange);
  }

  _onVolumeChange = () => {
    const isMuted = this._player.model.volume === 0;

    if (this._isMuted && !isMuted) {
      this.track();
    }

    this._isMuted = isMuted;
  };

  stop() {
    this._player.removeEventListener('volumechange', this._onVolumeChange);
  }
}
